import { SzczegolyPolaSpisu } from "../polaSpisu/szczegolyPolaSpisu";

export class PoleSpisuSrodkaDoZapisu {
    poleSpisu: SzczegolyPolaSpisu;
    wartosc: string;
    wartosciSlownika: Array<string>;
}